import { render, staticRenderFns } from "./InputMasked.vue?vue&type=template&id=06cba000"
import script from "./InputMasked.vue?vue&type=script&lang=js"
export * from "./InputMasked.vue?vue&type=script&lang=js"
import style0 from "./InputMasked.vue?vue&type=style&index=0&id=06cba000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports